// extracted by mini-css-extract-plugin
export default {"scope":"bYxH5","content":"pir8M","content--has-errors":"Wjc1i","handle":"kWzzB","drag-indicator":"+8mdf","form":"pYI8R","actions":"A+V02","remove-field":"_8w0gX"};